<div class="mt-2 mb-4">
  <ngx-skeleton-loader animation="pulse" [theme]="{
    'background': '#EAECEF',
    'border-radius': '5',
    'bottom': '0px',
    'height': '10px',
    'width': '111px',
  }"></ngx-skeleton-loader>
  <!-- <ngx-skeleton-loader animation="pulse" [theme]="{
      'background': '#EAECEF',
      'border-radius': '5',
      'bottom': '0px',
      'height': '17px',
      'margin-bottom': '10px',
      'width': '111px',
    }"></ngx-skeleton-loader>

  <div class="skeleton-wrapper">
    <div class="d-inline-table w-100 row-first">
      <div class="float-start column-first">
        <ngx-skeleton-loader animation="pulse" [theme]="{
            'background': '#EAECEF',
            'border-radius': '5',
            'height': '14px',
            'margin-bottom': '0px',
            'padding': '0px',
            'width': '64px'
            }"></ngx-skeleton-loader>
      </div>
      <div class="float-start">
        <ngx-skeleton-loader animation="pulse" [theme]="{
            'background': '#EAECEF',
            'border-radius': '5',
            'height': '14px',
            'margin-bottom': '0px',
            'padding': '0px',
            'width': '64px',
          }"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="d-inline-table w-100">
      <div class="float-start column-first">
        <ngx-skeleton-loader animation="pulse" [theme]="{
            'background': '#EAECEF',
            'border-radius': '5',
            'height': '31px',
            'margin-bottom': '0px',
            'padding': '0px',
            'width': '254px',
           }"></ngx-skeleton-loader>
      </div>
      <div class="float-start">
        <ngx-skeleton-loader animation="pulse" [theme]="{
            'background': '#EAECEF',
            'border-radius': '5',
            'height': '31px',
            'margin-bottom': '0px',
            'padding': '0px',
            'width': '254px',
          }"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="d-inline-block w-100">
      <ngx-skeleton-loader animation="pulse" [theme]="{
          'background': '#EAECEF',
          'border-radius': '5',
          'height': '40px',
          'margin-bottom': '0px',
          'margin-top': '20px',
          'padding': '0px'
          }"></ngx-skeleton-loader>
    </div>
  </div> -->
</div>